import Image, { ImageProps } from '@/components/Image';
import { mergePropsClassName } from '@/lib/helpers';
import * as style from './Card.css';
import { useCard } from './useCard';

export type CardImageProps = ImageProps & { hover?: boolean };

export const CardImage = ({ ShimProps = {}, hover = true, ...props }: CardImageProps) => {
  const { title, image } = useCard();

  return (
    image && (
      <Image
        alt={title ?? ''}
        aria-label={undefined}
        {...mergePropsClassName(
          {
            transform: 'landscapeLgCrop',
            ratio: 'landscapeWide',
            ...image,
            ...props,
          },
          style.image({ hover })
        )}
        ShimProps={mergePropsClassName(ShimProps, style.imageWrap)}
      />
    )
  );
};
